import { useMemo } from "react";
import { faRotateLeft, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Group } from "@mantine/core";
import { Tooltip } from "components/UI/Tooltip";
import { CollapsibleWidthComponent } from "containers/UI/TopEditMenu/CollapsibleComponent";
import { useTranslation } from "react-i18next";
import { useRouting } from "stores/routingStore/RoutingContext";
import buttonClasses from "./TopEditMenuButton.module.css";
import classes from "./UndoRedoButtons.module.css";

export const UndoRedoButtons = ({ isOpen }: { isOpen: boolean }) => {
  const {
    history: { canUndo, canRedo, undo, redo },
  } = useRouting();
  const { t } = useTranslation();

  return useMemo(
    () => (
      <CollapsibleWidthComponent height={28} width={57} isOpen={isOpen}>
        <Group wrap="nowrap" gap={1} className={classes.group}>
          <Tooltip label={t("editmode.undo_tooltip")}>
            <div>
              <ActionIcon
                variant="light"
                disabled={!canUndo}
                onClick={undo}
                aria-label={t("editmode.undo_tooltip")}
                className={buttonClasses.button}
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </ActionIcon>
            </div>
          </Tooltip>
          <Tooltip label={t("editmode.redo_tooltip")}>
            <div>
              <ActionIcon
                variant="light"
                disabled={!canRedo}
                onClick={redo}
                aria-label={t("editmode.redo_tooltip")}
                className={buttonClasses.button}
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <FontAwesomeIcon icon={faRotateRight} />
              </ActionIcon>
            </div>
          </Tooltip>
        </Group>
      </CollapsibleWidthComponent>
    ),
    [canRedo, canUndo, isOpen, redo, t, undo]
  );
};
